export const articles = [
  {
    id: 'liuyifei-xinju-loudian',
    slug: 'liuyifei-xinju-loudian',
    title: '刘亦菲新剧路透曝光！素颜状态引网友热议，这次真的翻车了？',
    excerpt: '近日有网友在某影视城偶遇刘亦菲拍摄新剧，素颜出镜状态引发全网讨论。皮肤暗沉、眼袋明显，与精修图差距悬殊...',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20actress%20candid%20photo%20on%20film%20set%20with%20natural%20lighting%20soft%20warm%20tones%20editorial%20photography%20with%20film%20grain%20texture%20artistic%20composition&width=800&height=600&seq=article-01&orientation=landscape',
    author: '吃瓜前线',
    date: '2026-07-06',
    readCount: 128350,
    rating: 8.7,
    tags: ['刘亦菲', '素颜', '新剧', '路透'],
    content: '近日有网友在某影视城偶遇刘亦菲拍摄新剧...',
    comments: [
      { user: '吃瓜群众甲', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20simple%20portrait%20neutral%20expression%20warm%20lighting%20clean%20background%20editorial%20style&width=100&height=100&seq=avatar-user01&orientation=squarish', content: '这素颜状态说实话还可以了，毕竟谁也不是天天都完美妆容', rating: 4 },
      { user: '八卦一线', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20adult%20avatar%20portrait%20natural%20look%20casual%20style%20warm%20minimal%20background&width=100&height=100&seq=avatar-user02&orientation=squarish', content: '看完我只想说，女神也是人啊，大家不要要求太高', rating: 5 },
      { user: '真相挖掘机', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20professional%20portrait%20clean%20background%20soft%20lighting%20editorial%20photography&width=100&height=100&seq=avatar-user03&orientation=squarish', content: '对比之前的精修图差距确实大，但底子好是真的', rating: 3 },
    ],
  },
  {
    id: 'wangyibo-jienu-hudong',
    slug: 'wangyibo-jienu-hudong',
    title: '王一博与粉丝互动翻车现场？现场视频流出引发两极分化评价',
    excerpt: '一段王一博在某活动现场与粉丝互动的视频近日在网上疯传，态度冷淡还是专业素养？网友吵翻了天...',
    category: '热门事件',
    categorySlug: 'remen-shijian',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20at%20public%20event%20with%20crowd%20soft%20warm%20ambient%20lighting%20candid%20moment%20editorial%20photography%20with%20cinematic%20mood&width=800&height=600&seq=article-02&orientation=landscape',
    author: '八卦雷达',
    date: '2026-07-06',
    readCount: 98720,
    rating: 7.9,
    tags: ['王一博', '粉丝互动', '翻车', '争议'],
    content: '一段王一博在某活动现场与粉丝互动的视频在网上引发热议...',
    comments: [
      { user: '理性吃瓜', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20casual%20portrait%20natural%20lighting%20minimal%20background%20editorial%20style%20clean%20composition&width=100&height=100&seq=avatar-user04&orientation=squarish', content: '看了完整视频，其实王一博态度没毛病，是被恶意剪辑了', rating: 5 },
      { user: '追星少女', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20avatar%20portrait%20warm%20natural%20light%20simple%20background%20editorial%20photography&width=100&height=100&seq=avatar-user05&orientation=squarish', content: '作为粉丝我觉得可以理解，他本来就是这个性格', rating: 4 },
    ],
  },
  {
    id: 'yangmi-shiye-xindongxiang',
    slug: 'yangmi-shiye-xindongxiang',
    title: '杨幂事业新动向！疑似签约国际大牌，工作室神秘发文引猜测',
    excerpt: '杨幂工作室今日发布一条意味深长的动态，配图引发粉丝疯狂猜测。据知情人士透露，杨幂可能即将签约某国际奢侈品牌...',
    category: '吃瓜爆料',
    categorySlug: 'chigua-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20fashion%20studio%20photography%20warm%20ambient%20light%20luxury%20aesthetic%20soft%20focus%20editorial%20style%20with%20sophisticated%20mood&width=800&height=600&seq=article-03&orientation=landscape',
    author: '明星情报站',
    date: '2026-07-05',
    readCount: 76540,
    rating: 8.2,
    tags: ['杨幂', '国际大牌', '签约', '时尚'],
    content: '杨幂工作室今日发布一条意味深长的动态...',
    comments: [
      { user: '时尚圈内人', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20professional%20portrait%20clean%20background%20neutral%20expression%20editorial%20photography&width=100&height=100&seq=avatar-user06&orientation=squarish', content: '据说是某法国奢侈品牌，代言费八位数起步', rating: 4 },
    ],
  },
  {
    id: 'zhangziyi-zhuboyan-luoxuan',
    slug: 'zhangziyi-zhuboyan-luoxuan',
    title: '章子怡直播带货首秀翻车？观众吐槽产品与描述严重不符',
    excerpt: '国际影后章子怡近日开启直播首秀，却因产品问题遭遇滑铁卢。直播间弹幕炸了，大量观众要求退款...',
    category: '吃瓜爆料',
    categorySlug: 'chigua-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20livestream%20shopping%20scene%20with%20studio%20lighting%20product%20display%20warm%20ambient%20atmosphere%20editorial%20photography%20realistic%20style&width=800&height=600&seq=article-04&orientation=landscape',
    author: '直播观察员',
    date: '2026-07-05',
    readCount: 156200,
    rating: 6.8,
    tags: ['章子怡', '直播带货', '翻车', '退款'],
    content: '国际影后章子怡近日开启直播首秀...',
    comments: [
      { user: '消费者权益', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20serious%20portrait%20clean%20background%20simple%20lighting%20editorial%20style&width=100&height=100&seq=avatar-user07&orientation=squarish', content: '明星带货请先了解产品好吗？消费者的钱不是大风刮来的', rating: 2 },
      { user: '理性观众', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20thoughtful%20expression%20portrait%20natural%20lighting%20editorial%20photography&width=100&height=100&seq=avatar-user08&orientation=squarish', content: '翻车归翻车，但章子怡的态度还是可以的，及时道歉了', rating: 3 },
    ],
  },
  {
    id: 'xiaozhan-xinzhuanji-fabu',
    slug: 'xiaozhan-xinzhuanji-fabu',
    title: '肖战新专辑发布在即！预告片播放量24小时破亿，创造新纪录',
    excerpt: '肖战个人第二张专辑预告片于昨日上线，24小时内全平台播放量突破1亿次，刷新了华语乐坛多项纪录...',
    category: '热门事件',
    categorySlug: 'remen-shijian',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20male%20singer%20album%20promotional%20visual%20artistic%20abstract%20warm%20dramatic%20lighting%20editorial%20photography%20cinematic%20mood%20creative%20composition&width=800&height=600&seq=article-05&orientation=landscape',
    author: '音乐榜中榜',
    date: '2026-07-04',
    readCount: 234500,
    rating: 9.1,
    tags: ['肖战', '新专辑', '破纪录', '华语乐坛'],
    content: '肖战个人第二张专辑预告片于昨日上线...',
    comments: [
      { user: '战战的小飞侠', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20avatar%20happy%20expression%20portrait%20warm%20lighting%20simple%20background&width=100&height=100&seq=avatar-user09&orientation=squarish', content: '这就是顶流的实力！期待新专辑，已经准备好钱包了', rating: 5 },
      { user: '乐评人老张', avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20person%20avatar%20intellectual%20portrait%20clean%20background%20professional%20lighting%20editorial%20style&width=100&height=100&seq=avatar-user10&orientation=squarish', content: '预告片制作水准确实高，期待完整专辑的呈现', rating: 5 },
    ],
  },
  {
    id: 'dilireba-hongtan-zhaoxing',
    slug: 'dilireba-hongtan-zhaoxing',
    title: '迪丽热巴红毯造型惊艳全场！外媒盛赞东方之美，却遭国内网友吐槽',
    excerpt: '迪丽热巴出席某国际电影节红毯，一袭定制礼服惊艳四座。外媒纷纷夸赞其展现了东方美，但国内网友却吵翻了...',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20on%20red%20carpet%20wearing%20stunning%20gown%20dramatic%20lighting%20fashion%20photography%20cinematic%20mood%20sophisticated%20aesthetic&width=800&height=600&seq=article-06&orientation=landscape',
    author: '时尚观察家',
    date: '2026-07-04',
    readCount: 189600,
    rating: 8.5,
    tags: ['迪丽热巴', '红毯', '造型', '争议'],
    content: '迪丽热巴出席某国际电影节红毯...',
    comments: [
      { user: '时尚达人', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20fashionable%20portrait%20clean%20background%20modern%20lighting%20editorial%20photography&width=100&height=100&seq=avatar-user11&orientation=squarish', content: '我觉得这套造型很美啊，不懂为什么有人要黑', rating: 5 },
      { user: '普通观众', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20casual%20portrait%20neutral%20expression%20natural%20light%20simple%20background&width=100&height=100&seq=avatar-user12&orientation=squarish', content: '确实好看，但是和之前某位女星的造型太像了', rating: 3 },
    ],
  },
  {
    id: 'caixukun-yinyuejie-huigui',
    slug: 'caixukun-yinyuejie-huigui',
    title: '蔡徐坤音乐节重磅回归！现场万人合唱场面震撼，黑粉都沉默了',
    excerpt: '时隔多日，蔡徐坤在某大型音乐节上惊喜亮相，带来全新改编的经典曲目。现场万人齐唱，场面让人动容...',
    category: '热门事件',
    categorySlug: 'remen-shijian',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20male%20performer%20on%20stage%20at%20music%20festival%20with%20massive%20crowd%20dramatic%20stage%20lighting%20concert%20photography%20epic%20atmosphere%20warm%20and%20energetic%20mood&width=800&height=600&seq=article-07&orientation=landscape',
    author: '音乐现场',
    date: '2026-07-03',
    readCount: 312000,
    rating: 9.3,
    tags: ['蔡徐坤', '音乐节', '回归', '万人合唱'],
    content: '时隔多日，蔡徐坤在某大型音乐节上惊喜亮相...',
    comments: [
      { user: 'IKUN永相随', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20avatar%20emotional%20expression%20portrait%20warm%20lighting%20clean%20background%20editorial%20photography&width=100&height=100&seq=avatar-user13&orientation=squarish', content: '看到坤坤回来我真的哭了，舞台上的他就是最闪耀的', rating: 5 },
      { user: '路转粉', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20surprised%20expression%20portrait%20natural%20lighting%20simple%20background%20editorial%20style&width=100&height=100&seq=avatar-user14&orientation=squarish', content: '以前对他无感，但这次现场真的太震撼了，实力没得黑', rating: 5 },
    ],
  },
  {
    id: 'zhaoliying-xinxi-shengzhi',
    slug: 'zhaoliying-xinxi-shengzhi',
    title: '赵丽颖新戏杀青！片场花絮曝光，敬业程度让剧组人员集体点赞',
    excerpt: '赵丽颖最新古装剧于近日杀青，剧组工作人员纷纷发文称赞其敬业精神。曝光的片场花絮中，赵丽颖亲身上阵完成高难度动作...',
    category: '吃瓜爆料',
    categorySlug: 'chigua-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20actress%20on%20historical%20drama%20film%20set%20wearing%20traditional%20costume%20warm%20natural%20lighting%20behind%20the%20scenes%20photography%20cinematic%20mood%20editorial%20style&width=800&height=600&seq=article-08&orientation=landscape',
    author: '剧透小能手',
    date: '2026-07-03',
    readCount: 98700,
    rating: 9.0,
    tags: ['赵丽颖', '新戏', '杀青', '敬业'],
    content: '赵丽颖最新古装剧于近日杀青...',
    comments: [
      { user: '颖火虫', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20admiring%20expression%20portrait%20warm%20light%20clean%20background%20editorial%20photography&width=100&height=100&seq=avatar-user15&orientation=squarish', content: '丽颖姐的敬业是圈内公认的，期待新剧播出！', rating: 5 },
    ],
  },
  {
    id: 'huachenyu-geci-zhengyi',
    slug: 'huachenyu-geci-zhengyi',
    title: '华晨宇新歌歌词再引争议！网友：这写的到底是什么？',
    excerpt: '华晨宇最新单曲发布后，歌词内容再次成为网友热议焦点。有人称其为天才创作，有人直言看不懂...',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20male%20singer%20artistic%20portrait%20abstract%20creative%20concept%20photography%20with%20warm%20dramatic%20lighting%20cinematic%20mood%20editorial%20style&width=800&height=600&seq=article-09&orientation=landscape',
    author: '乐评大实话',
    date: '2026-07-02',
    readCount: 145300,
    rating: 6.5,
    tags: ['华晨宇', '新歌', '歌词', '争议'],
    content: '华晨宇最新单曲发布后引发热议...',
    comments: [
      { user: '火星人', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20artistic%20portrait%20creative%20expression%20warm%20lighting%20editorial%20photography&width=100&height=100&seq=avatar-user16&orientation=squarish', content: '花花的音乐一直很有深度，看不懂是你水平不够', rating: 5 },
      { user: '吃瓜路人', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20confused%20expression%20portrait%20neutral%20background%20simple%20lighting&width=100&height=100&seq=avatar-user17&orientation=squarish', content: '说实话确实没看懂，但歌还挺好听的', rating: 3 },
    ],
  },
  {
    id: 'guanxiaotong-lianqing-bagua',
    slug: 'guanxiaotong-lianqing-bagua',
    title: '关晓彤恋情最新进展？两人同框吃饭被拍，细节透露感情状态',
    excerpt: '有网友在某高级餐厅偶遇关晓彤与男友共进晚餐，两人互动细节被放大解读。从微表情到肢体语言，吃瓜群众分析得头头是道...',
    category: '吃瓜爆料',
    categorySlug: 'chigua-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20dinner%20scene%20in%20upscale%20restaurant%20soft%20warm%20candlelight%20intimate%20atmosphere%20editorial%20photography%20with%20film%20grain%20texture%20cinematic%20composition&width=800&height=600&seq=article-10&orientation=landscape',
    author: '恋爱观察员',
    date: '2026-07-02',
    readCount: 267800,
    rating: 8.0,
    tags: ['关晓彤', '恋情', '同框', '八卦'],
    content: '有网友在某高级餐厅偶遇关晓彤与男友共进晚餐...',
    comments: [
      { user: '甜蜜暴击', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20romantic%20expression%20portrait%20warm%20lighting%20soft%20background%20editorial%20photography&width=100&height=100&seq=avatar-user18&orientation=squarish', content: '这对真的太甜了，每次同框都是糖分超标', rating: 5 },
      { user: '八卦协会会长', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20curious%20expression%20portrait%20clean%20background%20editorial%20photography&width=100&height=100&seq=avatar-user19&orientation=squarish', content: '这个角度拍到的，应该是狗仔蹲点蹲了好久吧', rating: 4 },
    ],
  },
];

export const categories = [
  { name: '吃瓜爆料', slug: 'chigua-baoliao', count: 128, description: '最新最全的娱乐圈吃瓜爆料，第一时间为你送上明星八卦猛料' },
  { name: '网红黑料', slug: 'wanghong-heiliao', count: 96, description: '网红圈黑料大起底，深扒那些不为人知的秘密' },
  { name: '热门事件', slug: 'remen-shijian', count: 85, description: '实时追踪全网最热事件，不错过任何一个热点' },
  { name: '实时追踪', slug: 'shishi-zhuizong', count: 72, description: '7x24小时不间断追踪娱乐圈最新动态' },
  { name: '视频更新', slug: 'shipin-gengxin', count: 54, description: '最新视频内容更新，高清画质畅享视觉盛宴' },
];

export const trendingKeywords = [
  '刘亦菲素颜', '王一博互动', '杨幂签约', '章子怡直播', '肖战新专辑',
  '迪丽热巴红毯', '蔡徐坤回归', '赵丽颖杀青', '华晨宇新歌', '关晓彤恋情',
];